var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3375_8607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6147 1.64314C5.81175 1.4439 6.07743 1.33333 6.35288 1.33333H9.64718C9.92263 1.33333 10.1883 1.4439 10.3854 1.64314C10.5827 1.84263 10.6948 2.11474 10.6948 2.4V4H5.30526V2.4C5.30526 2.11474 5.41741 1.84263 5.6147 1.64314ZM3.97193 4V2.4C3.97193 1.76584 4.22101 1.15619 4.6667 0.705555C5.11263 0.254667 5.71902 0 6.35288 0H9.64718C10.281 0 10.8874 0.254667 11.3334 0.705555C11.7791 1.15619 12.0281 1.76584 12.0281 2.4V4H15.4286C15.7442 4 16 4.29848 16 4.66667C16 5.03486 15.7442 5.33333 15.4286 5.33333H13.3335V13.6C13.3335 14.2342 13.0844 14.8438 12.6387 15.2944C12.1928 15.7453 11.5864 16 10.9525 16H5.04765C4.41379 16 3.8074 15.7453 3.36147 15.2944C2.91578 14.8438 2.6667 14.2342 2.6667 13.6V5.33333H0.571429C0.255837 5.33333 0 5.03486 0 4.66667C0 4.29848 0.255837 4 0.571429 4H3.97193ZM4.00003 5.33333V13.6C4.00003 13.8853 4.11217 14.1574 4.30947 14.3569C4.50652 14.5561 4.7722 14.6667 5.04765 14.6667H10.9525C11.228 14.6667 11.4936 14.5561 11.6907 14.3569C11.888 14.1574 12.0001 13.8853 12.0001 13.6V5.33333H4.00003Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3375_8607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1510835f4316b665d3fecd99690c10a6.svg";
export { ForwardRef as ReactComponent };